import { Page } from "../../../components/page-base";
import {
  BottomContainer,
  BtnsContainer,
  Container,
  FormRow,
  RegisterInputContainer,
} from "./styles";
import gpv from "../../../assets/images/logo-georanking.png";
import ActionButton from "../components/button";
import { InputLogin } from "../components/input";
import { LoginService } from "../services";
import GoogleIcon from "@mui/icons-material/Google";
import { useState } from "react";
import isMobile from "is-mobile";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useUserStore from "../../../store/user";
import { isValidUserType } from "../../../permissions";
import { destinoDepoisDoLogin } from "../../../utils/acesso-ao-relatorio";

export const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { setUser, setProfiles, setProfileAccesses } = useUserStore();
  const pedidoPorRelatorio = new URLSearchParams(window.location.search).get("relatorio") === "1";

  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      await LoginService.startGoogleOAuth();
    } finally {
      setLoading(false);
    }
  };

  const handleEmailLogin = async () => {
    if (!email || !password) {
      toast.error("Por favor, preencha e-mail e senha.");
      return;
    }
    setLoading(true);
    try {
      const token = await LoginService.login(email, password);
      if (!token) return;

      const res = await LoginService.getCurrentUser(token);
      const userType: string | undefined = res?.data?.userType;
      if (!userType || !isValidUserType(userType)) {
        toast.error("Não foi possível obter o tipo do usuário.");
        return;
      }

      const businessProfiles: string[] = res.data.businessProfiles ?? [];
      const profileAccesses = res.data.profileAccesses ?? [];

      setUser({
        name: res.data.name ?? "",
        token,
        userType,
        businessProfiles,
        profileAccesses,
      });
      setProfiles(businessProfiles);
      setProfileAccesses(profileAccesses);

      // Veio de um relatório aberto sem login: volta para ele.
      const destino = destinoDepoisDoLogin();
      if (destino) {
        navigate(destino, { replace: true });
        return;
      }

      if (userType === "CUSTOMER") {
        // Cliente escolhe o perfil (define tambem o nivel VIEW/EDIT no store).
        if (profileAccesses.length > 0 || businessProfiles.length > 0) {
          navigate("/select-profile");
        } else {
          navigate("/home");
        }
      } else {
        navigate("/admin");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page.Root>
      <Container>
        <FormRow>
          <div className="left-item">
            <img src={gpv} alt="" className="left-image" />
            <span className="left-title">Fazer login</span>
            <span className="left-subtitle">
              Gerencie o ranqueamento e a performance da sua empresa no Google
            </span>
            {pedidoPorRelatorio && (
              <span className="left-subtitle" role="status" style={{ fontWeight: 700 }}>
                Entre com seu login para ver o relatório.
              </span>
            )}
          </div>
          <div className="right-item">
            <RegisterInputContainer>
              <InputLogin
                placeholder="Email"
                type="text"
                setValue={setEmail}
                value={email}
              />
              <InputLogin
                placeholder="Senha"
                type="password"
                setValue={setPassword}
                value={password}
              />
            </RegisterInputContainer>
            <BtnsContainer>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <ActionButton label="Entrar" onClick={handleEmailLogin} />
                <a
                  style={{
                    fontSize: "14px",
                    color: "#4285f4",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/forgot-password")}
                >
                  Esqueceu a senha?
                </a>
                <ActionButton
                  label="Login com Google"
                  onClick={handleGoogleLogin}
                  icon={<GoogleIcon />}
                />
                <a
                  href="/login/admin"
                  style={{
                    fontSize: "14px",
                    color: "#4285f4",
                    textDecoration: "none",
                    marginTop: isMobile() ? "2vh" : "0",
                  }}
                >
                  Acesso administrador
                </a>
                {import.meta.env.VITE_DEV && (
                  <a
                    href="/login/dev"
                    style={{
                      fontSize: "14px",
                      color: "#e65100",
                      textDecoration: "none",
                    }}
                  >
                    Acesso desenvolvimento
                  </a>
                )}
              </div>
            </BtnsContainer>
          </div>
        </FormRow>
      </Container>

      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(255,255,255,0.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
          aria-busy
          aria-live="assertive"
        >
          <Page.Loader />
        </div>
      )}
      <BottomContainer>
        <a
          href="/terms-of-use"
          target="_blank"
          rel="noopener"
          style={{ marginRight: "1vw" }}
        >
          Termos de Uso
        </a>
        <a href="/privacy-policy" target="_blank" rel="noopener">
          Política de Privacidade
        </a>
      </BottomContainer>
    </Page.Root>
  );
};
